import { InitialQueryData } from '@data/queries/types'
import { logError } from '@util/logger'
import { objectKeysArray } from '@util/object'

export const exposeExperimentsToNewRelic = (initialQueryData: InitialQueryData): void => {
    const { experiments } = initialQueryData

    if (
        typeof newrelic === 'undefined' ||
        typeof window === 'undefined' ||
        window.newrelic === undefined ||
        !experiments ||
        Object.keys(experiments).length === 0
    ) {
        return
    }

    objectKeysArray(experiments).forEach((experimentName) => {
        const segment = experiments[experimentName]

        if (!segment) {
            logError(`Segment not defined for ${experimentName} in IN_DATA`)
            return
        }

        newrelic.setCustomAttribute(`experiment_${experimentName}`, segment)
    })
}
